"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const Box_1 = require("./Box");
exports.Input = Box_1.Box.withComponent('input');
exports.Input.defaultProps = {
    type: 'text',
    opaque: true,
    palette: 'white',
};

//# sourceMappingURL=Input.js.map
